import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/WormRobot/1_1x.png`;
const Pic2 = `${FullPath}/WormRobot/2_1x.png`;
const Pic3 = `${FullPath}/WormRobot/3_1x.png`;
const Pic4 = `${FullPath}/WormRobot/4_1x.png`;
const Pic5 = `${FullPath}/WormRobot/5_1x.png`;
const Pic6 = `${FullPath}/WormRobot/6_1x.png`;
const Pic7 = `${FullPath}/WormRobot/7_1x.png`;
const Pic8 = `${FullPath}/WormRobot/8_1x.png`;
const Pic9 = `${FullPath}/WormRobot/9_1x.png`;
const Pic10 = `${FullPath}/WormRobot/10_1x.png`;
const Pic11 = `${FullPath}/WormRobot/11_1x.png`;
const Pic12 = `${FullPath}/WormRobot/12_1x.png`;
const Pic13 = `${FullPath}/WormRobot/13_1x.png`;
const Pic14 = `${FullPath}/WormRobot/14_1x.png`;
const Pic15 = `${FullPath}/WormRobot/15_1x.png`;
const Pic16 = `${FullPath}/WormRobot/16_1x.png`;
const Pic17 = `${FullPath}/WormRobot/17_1x.png`;
const Pic18 = `${FullPath}/WormRobot/18_1x.png`;
const Pic19 = `${FullPath}/WormRobot/19_1x.png`;
const Pic20 = `${FullPath}/WormRobot/20_1x.png`;
const Pic21 = `${FullPath}/WormRobot/21_1x.png`;
const Pic22 = `${FullPath}/WormRobot/22_1x.png`;
const Pic23 = `${FullPath}/WormRobot/23_1x.png`;
const Pic24 = `${FullPath}/WormRobot/24_1x.png`;
const Pic25 = `${FullPath}/WormRobot/25_1x.png`;
const Pic26 = `${FullPath}/WormRobot/26_1x.png`;
const Pic27 = `${FullPath}/WormRobot/27_1x.png`;
const Pic28 = `${FullPath}/WormRobot/28_1x.png`;
const Pic29 = `${FullPath}/WormRobot/29_1x.png`;
const Pic30 = `${FullPath}/WormRobot/30_1x.png`;
const Pic31 = `${FullPath}/WormRobot/31_1x.png`;
const Pic32 = `${FullPath}/WormRobot/32_1x.png`;
const Pic33 = `${FullPath}/WormRobot/33_1x.png`;
const Pic34 = `${FullPath}/WormRobot/34_1x.png`;
const Pic35 = `${FullPath}/WormRobot/35_1x.png`;
const Pic36 = `${FullPath}/WormRobot/36_1x.png`;
const Pic37 = `${FullPath}/WormRobot/37_1x.png`;
const Pic38 = `${FullPath}/WormRobot/38_1x.png`;
const Pic39 = `${FullPath}/WormRobot/39_1x.png`;
const Pic40 = `${FullPath}/WormRobot/40_1x.png`;
const Pic41 = `${FullPath}/WormRobot/41_1x.png`;
const Pic42 = `${FullPath}/WormRobot/42_1x.png`;



export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
        Pic20,
        Pic21,
        Pic22,
        Pic23,
        Pic24,
        Pic25,
        Pic26,
        Pic27,
        Pic28,
        Pic29,
        Pic30,
        Pic31,
        Pic32,
        Pic33,
        Pic34,
        Pic35,
        Pic36,
        Pic37,
        Pic38,
        Pic39,
        Pic40,
        Pic41,
        Pic42,
     

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}